import gql from 'graphql-tag';

import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import { VISIT_WITH_ORGANIZATION_FIELDS } from '../../fragments/trippy/visitWithOrganizationFields';
import { GetVisitsWithOrgMembers } from '../../athena/types/GetVisitsWithOrgMembers';

export const GET_VISITS_WITH_ORG_MEMBERS = gql`
  query GetVisitsWithOrgMembers($visitIds: [String!]!) {
    trippy {
      getVisits(input: { visitIds: $visitIds }) {
        visits {
          ...VisitWithOrganizationFields
        }
      }
    }
  }

  ${VISIT_WITH_ORGANIZATION_FIELDS}
`;

const useGetVisitsWithOrgMembers = (options?: QueryHookOptions<GetVisitsWithOrgMembers>) =>
  useQuery<GetVisitsWithOrgMembers>(GET_VISITS_WITH_ORG_MEMBERS, options);

export default useGetVisitsWithOrgMembers;
